'use client';

import { SettingsModule, SettingsOverlay } from '@sushiswap/ui';
export const CrossChainSwapSettingsOverlay = () => {
  return <SettingsOverlay modules={[SettingsModule.SlippageTolerance]} data-sentry-element="SettingsOverlay" data-sentry-component="CrossChainSwapSettingsOverlay" data-sentry-source-file="cross-chain-swap-settings-overlay.tsx" />;
};